import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Input, Row, Col, FormFeedback, Label, UncontrolledTooltip, Tooltip, Popover, PopoverHeader, PopoverBody } from 'reactstrap';

const allowKeys = [8, 9, 13, 16, 18, 33, 34, 35, 36, 37, 38, 39, 40, 46];

class ParadigmaLabeledInput extends Component {
	constructor(props) {
		super(props);
		this.state = {
			value: this.props.value,
			tooltipID: this.NewID(),
		};
	}

	static propTypes = {
		onChange: PropTypes.func,
		onExternalChange: PropTypes.func,
		label: PropTypes.string.isRequired,
		fieldName: PropTypes.string,
		labelColumns: PropTypes.number.isRequired,
		fieldColumns: PropTypes.number.isRequired,
		inputComponent: PropTypes.any,
		disabled: PropTypes.bool,
		type: PropTypes.string,
		rows: PropTypes.number,
		value: PropTypes.any,

		marginLeftAuto: PropTypes.bool,
		labelClassName: PropTypes.string,
		fieldClassName: PropTypes.string,

		tooltip: PropTypes.string,
		tooltipHeader: PropTypes.string,

		style: PropTypes.object,

		maxLength: PropTypes.number
	}


	componentWillReceiveProps(nextProps) {
		if (this.props.value != nextProps.value) {
			this.setState({ value: nextProps.value });
		}
	}



	keyDown(e) {
		if (this.props.type == "number") {
			if (allowKeys.indexOf(e.keyCode) > -1) return;

			if (!isNaN(e.key)) {
			} else {
				if (e.key == "." || e.key == ",") {
					if (e.target.value.indexOf('.') > -1) {
						e.preventDefault();
					}
					else if (e.key == ",") {
						e.preventDefault();
						e.target.value += ".";
					}
				} else {
					e.preventDefault();
				}
			}
		}
	}

	NewID() {
		var text = "";
		var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";

		for (var i = 0; i < 5; i++)
			text += possible.charAt(Math.floor(Math.random() * possible.length));

		return text;
	}

	render() {
		var inputComponent = <Input
			maxLength={this.props.maxLength}
			style={this.props.style}
			value={this.state.value}
			disabled={this.props.disabled}
			className={this.props.type ? (this.props.type != "number" ? "" : "text-right") : ""}
			type={this.props.type ? (this.props.type != "number" ? this.props.type : "text") : "text"}
			rows={this.props.rows ? this.props.rows : null}
			name={this.props.fieldName}
			onKeyDown={(e) => this.keyDown(e)}
			onChange={(e) => { this.setState({ value: e.target.value }); if (this.props.onChange) { this.props.onChange(e); } }}
		></Input>;

		if (this.props.inputComponent) inputComponent = this.props.inputComponent;

		let tp = (this.props.tooltip ? <i

			id={this.state.tooltipID} className="fa fa-info ml-1"
			onMouseEnter={() => this.setState({ tooltipOpen: true })}
			onMouseLeave={() => this.setState({ tooltipOpen: false })}
		>
			<Popover isOpen={this.state.tooltipOpen}
				placement={"top"} target={"#" + this.state.tooltipID}>
				<PopoverHeader>{this.props.tooltipHeader}</PopoverHeader>
				<PopoverBody>
					{this.props.tooltip}
				</PopoverBody>

			</Popover></i> : null);

		return (
			<Row style={this.props.style} className="mt-sm-1">
				<Col className={(this.props.marginLeftAuto ? "ml-sm-auto " : "") + "col-12 col-sm-" + this.props.labelColumns.toString() + " pr-sm-0  " + this.props.labelClassName}>
					<Label>{this.props.label}{tp}</Label>
				</Col>
				<Col className={"col-12 col-sm-" + this.props.fieldColumns.toString() + " " + this.props.fieldClassName}>
					{inputComponent}
					<FormFeedback></FormFeedback>
				</Col>
			</Row>
		);
	}
};

module.exports = ParadigmaLabeledInput;


// WEBPACK FOOTER //
// ./src/components/ParadigmaLabeledInput/ParadigmaLabeledInput.js